// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"29e888ec","816":"73141e39"}[chunkId] + ".chunk.js";
};